$(document).ready(function() {
    initSlideshow();
    Search.init();
});

function initSlideshow() {
    let slideshow = $('#slideshow');
    if (slideshow.length < 1) {
        return false;
    }
    let thumbnailContainer = $('.slide-thumbs', slideshow);
    let thumbs = $('.thumb', thumbnailContainer);
    let mainContainer = $('.carousel-inner', slideshow);
    let slideInterval = null;

    initLargeImage();
    if (thumbnailContainer.length < 1) {
        return false;
    }
    initThumbnails();

    function initLargeImage() {
        mainContainer.swipeDetector();
        mainContainer.on('swipeRight.sd', function() {
            slideshow.carousel('prev');
        });
        mainContainer.on('swipeLeft.sd', function() {
            slideshow.carousel('next');
        });

        slideshow.on('slide.bs.carousel', function(event) {
            thumbnailContainer.slick('slickGoTo', event.to);
        });
    }

    function initThumbnails() {
        let slideshow_speed = 7000;
        if (typeof SLIDESHOW_SPEED != 'undefined') {
            slideshow_speed = SLIDESHOW_SPEED;
        }

        let slides_to_show = 3;
        if (typeof SLIDES_TO_SHOW != 'undefined') {
            slides_to_show = SLIDES_TO_SHOW;
            slides_to_show =
                slides_to_show <= thumbs.length
                    ? slides_to_show
                    : thumbs.length;
        }

        thumbnailContainer.on('init', function(event, slick) {
            let time = 0;
            $('.thumb.slick-active').each(function() {
                let elem = $(this);
                setTimeout(function() {
                    elem.addClass('show');
                }, time);
                time += 300;
            });
            $('.thumb:not(.slick-active)').addClass('show');
        });

        thumbnailContainer.on('beforeChange', function(
            event,
            slick,
            currentSlide,
            nextSlide
        ) {
            slideshow.carousel(nextSlide);
            thumbs.removeClass('active');
            thumbs.eq(nextSlide).addClass('active');
            clearInterval(slideInterval);
            manualSliding();
        });

        let center_mode = slides_to_show % 2 == 1;

        thumbnailContainer.slick({
            vertical: true,
            arrows: false,
            centerMode: center_mode,
            slidesToShow: slides_to_show,
            infinite: true,
            centerPadding: '0',
            verticalSwiping: true,
            swipeToSlide: true,
            initialSlide: 0,
            pauseOnFocus: false,
            pauseOnHover: false,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });

        setThumbnailPadding();

        setTimeout(function() {
            thumbs.eq(0).addClass('active');
            manualSliding();
        });

        if (
            thumbs.length <=
            thumbnailContainer.get(0).slick.options.slidesToShow
        ) {
            slideshow.find('.slick-track').addClass('no-transform');
        }

        function manualSliding() {
            slideInterval = setInterval(function() {
                if (
                    thumbnailContainer.slick('slickCurrentSlide') <
                    thumbs.length - 1
                ) {
                    thumbnailContainer.slick(
                        'slickGoTo',
                        thumbnailContainer.slick('slickCurrentSlide') + 1
                    );
                } else {
                    thumbnailContainer.slick('slickGoTo', 0);
                }
            }, slideshow_speed);
        }

        fixVerticalSliding();

        thumbs.click(function() {
            thumbnailContainer.slick('slickGoTo', $(this).data('slide-to'));
        });
    }
}


window.addEventListener('scroll', function(){
    processHeaderClass()
});

let headerElem = document.getElementsByTagName('header');
let prevScrollTop = 0;
let headerStartHeight = headerElem.clientHeight;

function processHeaderClass() {
    if (!headerElem) {
        return false;
    }

    if (Math.abs(prevScrollTop - window.scrollY) > 10) {
        $(headerElem).toggleClass(
            'scroll-down',
            prevScrollTop < window.scrollY
        );
        $(headerElem).toggleClass('scroll-up', prevScrollTop > window.scrollY);
    }

    // if (window.scrollY >= headerStartHeight) {
    //     headerElem.classList.add('scrolled');
    // } else {
    //     headerElem.classList.remove('scrolled');
    // }
    prevScrollTop = window.scrollY;
}

if($('#carouselExampleControls').length) {
    makeNewProgress(4700);
}


function makeNewProgress (slideTime) {
    $('.active').append("<div class=\"time-left\"></div>");
    let progressRing = document.querySelector('.active .time-left');
    var myProgress = new ProgressBar.Circle(progressRing, {
        color: '#FFF',
        strokeWidth: 9.1,
        svgStyle: {
          display: 'block',
          width: '22px',
        },
        fill: null,
        duration: slideTime,
        easing: 'linear',
        warnings: false
    });
    myProgress.animate(1);
}

$('#carouselExampleControls').on('slide.bs.carousel', function () {
    $('.active').find('div.time-left').remove();
});


$('#carouselExampleControls').on('slid.bs.carousel', function () {
    makeNewProgress(4400);
});


$('.popover-carousel').on('click', function(e) {
    popOverGallery(this);
    e.stopPropagation();
})

$(document.body).on('click', function(e) {
    if($(document.body).find('.popover-content').is(":visible") && $(e.target).attr('class').split(" ")[0] != 'popover-open' ) {
        $(document.body).find('.popover-content').hide();
        $(document.body).find('.popover-carousel').removeClass('clicked');
    }
});

function popOverGallery(element) {
    if($(document.body).find('.popover-content').is(":visible")) {
        $(document.body).find('.popover-content').hide();
        if(!$(element).hasClass('clicked')) {
            $(document.body).find('.popover-carousel').removeClass('clicked');
            popOverGallery(element);
        }
        else {
            $(document.body).find('.popover-carousel').removeClass('clicked');
        }
    }
    else {
        $(element).parent().find('.popover-content').show();
        $(element).addClass('clicked');
    }
}

$('.disable-link').on('click', function(e){
    if (window.matchMedia('(max-width: 767px)').matches) {
        e.preventDefault();
    }
});

$('.cancel-btn').on('click', function() {
    $(this).parent().hide();
});


var Search = {
    from: null,
    init: function () {
        var timeout;

        $("#search, #search-mobile").keyup(function () {
            if (timeout) {
                clearTimeout(timeout);
            }

            var q = $(this).val();
            var form = $(this).closest('form');
            var categories = $('[name="categories[]:checked"]', form);
            var categoryVal = [];
            var link = form.data('autocomplete-src');

            if (categories.length > 0) {
                categories.each(function () {
                    categoryVal.push($(this).val());
                });
            }

            if (q.length > 3) {
                timeout = setTimeout(function () {
                    $('#autocomplete-suggestions').addClass('visible');
                    $('#autocomplete-suggestions').html("ir dummy rezultāts2");
                    $('.autocomplete-results .result').html("ir dummy rezultātsir dummy rezultātsir dummy rezultātsir dummy rezultātsir dummy rezultātsir dummy rezultāts").show();
                    $('.autocomplete-results').show();
                }, 500);
            }
        });

        $("#SearchForm, #MobileSearchForm").on('submit', function () {
            clearTimeout(timeout);
            $(this).find('.autocomplete-results').hide();
        });

        $('.white-overlay').on('click', function () {
            $('#close-btn').click();
        });
    }
}

